<template>
  <div class="shaft-element-layout">
    <HeaderBar :modifiers="['transparent', 'more-padding', 'more-height']">
      <a
        class="button"
        @click="$router.back()"
      >
        <ArrowLeftSvg />
      </a>

      <template #right>
        <a
          class="button"
          @click="$router.back()"
        >
          {{ $t("general.cancel") }}
        </a>
        <FormSubmitButton
          :isSaving="saving"
          @click="saveNewElement"
        />
      </template>
    </HeaderBar>

    <div
      class="
        definition-layout__group-form
        definition-layout__group-form--less-view-height
      "
    >
      <div
        class="
          definition-layout__group-form--content
          definition-layout__group-form--content--padding-around
        "
      >
        <div class="form-layout form-layout--default">
          <div class="form-layout__content">
            <h2 class="form-layout__title typo-small-title">
              {{ $t("shafts.group.add_name", { type: addLabel }) }}
            </h2>

            <hr>
            <h2 class="form-layout__title typo-small-title">
              {{ $t("shafts.group.element_details") }}
            </h2>
            <!-- TODO: Replace with real text -->
            <!-- <p
              class="form-layout__description form-layout__description--margin-bottom typo-small-title"
            >
              {{ $t("shafts.group.element_description") }}
            </p> -->

            <div
              class="
                form-layout__row
                form-layout__row--inline
                form-layout__row--space-between
              "
            >
              <div class="form-layout__column form-layout__column--large">
                <FormRow
                  :errors="errors?.shaft_element?.name"
                  :label="
                    $t('shafts.group.element_name', { type: elementNameText })
                  "
                  labelFor="shaft_element_name"
                  :modifiers="['no-padding']"
                >
                  <div class="form-row__input form-row__input--no-peek">
                    <div
                      :class="{
                        input: true,
                        'input--error': errors?.shaft_element?.name,
                      }"
                    >
                      <input
                        id="shaft_element_name"
                        v-model="element.name"
                        @blur="validateInput('name')"
                      >
                    </div>
                  </div>
                </FormRow>
              </div>

              <div
                class="
                  form-layout__column
                  form-layout__column--small
                  form-layout__column--inline
                "
              >
                <FormRow
                  :errors="errors?.shaft_element?.symbol"
                  :label="$t('shafts.group.symbol')"
                  labelFor="shaft_element_symbol"
                  :modifiers="['no-padding']"
                >
                  <div class="form-row__input form-row__input--no-peek">
                    <div
                      :class="{
                        input: true,
                        'input--error': errors?.shaft_element?.symbol,
                      }"
                    >
                      <input
                        id="shaft_element_symbol"
                        v-model="element.symbol"
                        @blur="validateInput('symbol')"
                        @keyup="updateDiagram"
                      >
                    </div>
                  </div>
                </FormRow>
              </div>

              <div
                class="
                  form-layout__column
                  form-layout__column--small
                  form-layout__column--inline
                "
              >
                <FormRow
                  :errors="errors?.shaft_element?.shaft_element_group"
                  :label="$t('shafts.group.group')"
                  labelFor="shaft_element_group"
                  :modifiers="['no-padding']"
                >
                  <div class="form-row__input form-row__input--no-peek">
                    <GroupSelect
                      v-model="selectedGroup"
                      :class="{
                        'input--error':
                          errors?.shaft_element?.shaft_element_group,
                      }"
                      :groups="shaftElementGroups"
                    />
                  </div>
                </FormRow>
              </div>
            </div>

            <hr>

            <h2 class="form-layout__title typo-small-title">
              {{ $t("shafts.group.set.label") }}
            </h2>
            <!-- TODO: Replace with real text -->
            <!-- <p
              class="form-layout__description form-layout__description--margin-bottom typo-small-title"
            >
              {{ $t("shafts.group.set.description") }}
            </p> -->

            <div
              class="
                form-layout__row--mobile
                form-layout__row--inline
                form-layout__row--left
                form-layout__row--small
              "
            >
              <div
                class="
                  form-layout__column
                  form-layout__column--mobile
                  form-layout__column--inline
                  form-layout__column--small
                "
              >
                <FormRow
                  :errors="errors?.shaft_element?.start_set"
                  :label="$t('shafts.group.set.start_set')"
                  labelFor="shaft_element_start_set"
                  :modifiers="['no-padding']"
                >
                  <div class="form-row__input form-row__input--no-peek">
                    <div
                      :class="{
                        input: true,
                        'input--error': errors?.shaft_element?.start_set,
                      }"
                    >
                      <input
                        id="shaft_element_start_set"
                        v-model="element.start_set"
                        @blur="!startSetWasTouched && validateInput('start_set', 'number')"
                      >
                    </div>
                  </div>
                </FormRow>
              </div>

              <div
                class="
                  form-layout__column
                  form-layout__column--mobile
                  form-layout__column--inline
                  form-layout__column--small
                "
              >
                <FormRow
                  :errors="errors?.shaft_element?.end_set"
                  :label="$t('shafts.group.set.end_set')"
                  labelFor="shaft_element_end_set"
                  :modifiers="['no-padding']"
                >
                  <div class="form-row__input form-row__input--no-peek">
                    <div
                      :class="{
                        input: true,
                        'input--error': errors?.shaft_element?.end_set,
                      }"
                    >
                      <input
                        id="shaft_element_end_set"
                        v-model="element.end_set"
                        @blur="!endSetWasTouched && validateInput('end_set', 'number')"
                      >
                    </div>
                  </div>
                </FormRow>
              </div>
            </div>

            <div v-if="riskList">
              <hr>

              <h2 class="form-layout__title typo-small-title">
                {{ $t("shafts.group.risk.label") }}
              </h2>
              <!-- TODO: Replace with real text -->
              <!-- <p
                class="form-layout__description form-layout__description--margin-bottom typo-small-title"
              >
                {{ $t("shafts.group.risk.description") }}
              </p> -->

              <div
                class="
                  form-layout__row--mobile
                  form-layout__row--inline
                  form-layout__row--center
                  form-layout__row--space-between
                "
              >
                <div
                  class="
                    form-layout__row--mobile
                    form-layout__row--inline
                    form-layout__row--center
                    form-layout__row--left
                  "
                >
                  <div
                    v-for="(risk, index) in riskList"
                    :key="risk"
                    class="
                      form-layout__column
                      form-layout__column--min-width
                      form-layout__column--no-margin-left
                      form-layout__column--check
                    "
                  >
                    <div
                      :class="{
                        'form-row__fields checkbox': true,
                        'checkbox--incomplete':
                          !errors?.shaft_element[risk.name],
                        'checkbox--error': errors?.shaft_element[risk.name],
                      }"
                    >
                      <input
                        :id="`${risk.name}_${index}`"
                        v-model="element[`risk_to_${convertToUnderscore(risk.value)}`]"
                        class="checkbox__input"
                        :name="`${risk.name}_${index}`"
                        type="checkbox"
                        :value="risk.value"
                      >
                      <label
                        class="checkbox__label"
                        :for="`${risk.name}_${index}`"
                      >
                        {{ $t(`shafts.group.risk.${convertToUnderscore(risk.value)}`) }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="sizeList">
              <hr>
              <h2 class="form-layout__title typo-small-title">
                {{ $t("shafts.group.size.label") }}
              </h2>
              <!-- TODO: Replace with real text -->
              <!-- <p
                class="form-layout__description form-layout__description--margin-bottom typo-small-title"
              >
                {{ $t("shafts.group.size.description") }}
              </p> -->

              <div
                class="
                  form-layout__row--mobile
                  form-layout__row--inline
                  form-layout__row--center
                  form-layout__row--left
                "
              >
                <div
                  v-for="(size, index) in sizeList"
                  :key="size"
                  class="
                    form-layout__column
                    form-layout__column--mobile
                    form-layout__column--small
                    form-layout__column--check
                  "
                >
                  <div
                    :class="{
                      'form-row__fields checkbox checkbox--rounded': true,
                      'checkbox--incomplete': !errors?.shaft_element[size.name],
                      'checkbox--error': errors?.shaft_element[size.name],
                    }"
                  >
                    <input
                      :id="`${size.name}_${index}`"
                      v-model="element.geometry[size.name]"
                      class="checkbox__input"
                      :name="size.name"
                      type="radio"
                      :value="size.value"
                      @change="updateDiagram"
                    >
                    <label
                      class="checkbox__label"
                      :for="`${size.name}_${index}`"
                    >
                      {{ $t(`shafts.group.size.${convertToUnderscore(size.label)}`) }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="typeList">
              <hr>
              <h2 class="form-layout__title typo-small-title">
                {{
                  elementType === "skips_and_cages"
                    ? $t("shafts.group.type.member_label")
                    : $t("shafts.group.type.label")
                }}
              </h2>
              <!-- TODO: Replace with real text -->
              <!-- <p
                class="form-layout__description form-layout__description--margin-bottom typo-small-title"
              >
                {{ $t("shafts.group.type.description") }}
              </p> -->

              <div
                class="
                  form-layout__row--mobile
                  form-layout__row--inline
                  form-layout__row--center
                  form-layout__row--left
                "
              >
                <div
                  v-for="(type, index) in typeList"
                  :key="type"
                  class="
                    form-layout__column
                    form-layout__column--mobile
                    form-layout__column--small
                    form-layout__column--check
                  "
                >
                  <div
                    :class="{
                      'form-row__fields checkbox checkbox--rounded': true,
                      'checkbox--incomplete': !errors?.shaft_element[type.name],
                      'checkbox--error': errors?.shaft_element[type.name],
                    }"
                  >
                    <input
                      :id="`${type.name}_${index}`"
                      v-model="element.geometry[type.name]"
                      class="checkbox__input"
                      :name="type.name"
                      type="radio"
                      :value="type.value"
                    >
                    <label
                      class="checkbox__label"
                      :for="`${type.name}_${index}`"
                    >
                      {{ $t(`shafts.group.type.${convertToUnderscore(type.value)}`) }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <hr>

            <h2 class="form-layout__title typo-small-title">
              {{
                $t("shafts.group.dimension_label", { type: elementNameText })
              }}
            </h2>
            <p
              class="
                form-layout__description form-layout__description--margin-bottom
                typo-small-title
              "
            >
              {{ $t("shafts.group.dimensions_description") }}
            </p>

            <div
              class="form-layout__row form-layout__row--inline"
              :class="{
                'relate-svg-group__error':
                  errors?.shaft_element?.width || errors?.shaft_element?.height,
                'form-layout__row--space-between relate-svg-group':
                  showWidthAndHeight,
                'form-layout__row--left form-layout__row--small':
                  !showWidthAndHeight,
              }"
            >
              <div
                class="
                  form-layout__column
                  form-layout__column--small
                  form-layout__column--inline
                "
              >
                <FormRow
                  :errors="errors?.shaft_element?.x"
                  :label="$t('shafts.group.x_position')"
                  labelFor="shaft_element_x_position"
                  :modifiers="['no-padding']"
                >
                  <div class="form-row__input form-row__input--no-peek">
                    <div
                      :class="{
                        input: true,
                        'input--error': errors?.shaft_element?.x,
                      }"
                    >
                      <input
                        id="shaft_element_x_position"
                        v-model="element.geometry.x"
                        :max="minMaxBoundary.max"
                        :min="minMaxBoundary.min"
                        type="number"
                        @blur="validateInput('x', 'number')"
                        @change="updateDiagram"
                        @keyup="updateDiagram"
                      >
                    </div>
                  </div>
                </FormRow>
              </div>
              <div
                class="
                  form-layout__column
                  form-layout__column--small
                  form-layout__column--inline
                "
              >
                <FormRow
                  :errors="errors?.shaft_element?.y"
                  :label="$t('shafts.group.y_position')"
                  labelFor="shaft_element_y_position"
                  :modifiers="['no-padding']"
                >
                  <div class="form-row__input form-row__input--no-peek">
                    <div
                      :class="{
                        input: true,
                        'input--error': errors?.shaft_element?.y,
                      }"
                    >
                      <input
                        id="shaft_element_y_position"
                        v-model="element.geometry.y"
                        :max="minMaxBoundary.max"
                        :min="minMaxBoundary.min"
                        type="number"
                        @blur="validateInput('y', 'number')"
                        @change="updateDiagram"
                        @keyup="updateDiagram"
                      >
                    </div>
                  </div>
                </FormRow>
              </div>
              <div
                v-if="showWidthAndHeight"
                class="
                  form-layout__column
                  form-layout__column--small
                  form-layout__column--inline
                "
              >
                <FormRow
                  :errors="errors?.shaft_element?.width"
                  :label="$t('shafts.group.width')"
                  labelFor="shaft_element_width"
                  :modifiers="['no-padding']"
                >
                  <div class="form-row__input form-row__input--no-peek">
                    <div
                      class="relate-svg-item"
                      :class="{
                        input: true,
                        'input--error': errors?.shaft_element?.width,
                      }"
                    >
                      <input
                        id="shaft_element_width"
                        v-model="element.geometry.width"
                        :min="minMaxBoundary.min"
                        type="number"
                        @blur="validateInput('width', 'number')"
                        @change="updateDiagram"
                        @keyup="updateDiagram"
                      >
                    </div>
                  </div>
                </FormRow>
              </div>
              <div
                v-if="showWidthAndHeight"
                class="
                  form-layout__column
                  form-layout__column--small
                  form-layout__column--inline
                "
              >
                <FormRow
                  :errors="errors?.shaft_element?.height"
                  :label="$t('shafts.group.height')"
                  labelFor="shaft_element_height"
                  :modifiers="['no-padding']"
                >
                  <div class="form-row__input form-row__input--no-peek">
                    <div
                      :class="{
                        input: true,
                        'input--error': errors?.shaft_element?.height,
                      }"
                    >
                      <input
                        id="shaft_element_height"
                        v-model="element.geometry.height"
                        :min="minMaxBoundary.min"
                        type="number"
                        @blur="validateInput('height', 'number')"
                        @change="updateDiagram"
                        @keyup="updateDiagram"
                      >
                    </div>
                  </div>
                </FormRow>
              </div>
            </div>
          </div>
        </div>
        <Loader v-if="loading" />
      </div>

      <!-- Shaft diagram (right panel) -->
      <div class="definition-layout__right-form">
        <Loader v-if="loadingDiagram || !shaft" />
        <DefinitionDiagram
          v-else
          :elementType="elementType"
          :minMax="minMaxBoundary"
          :modifiers="['border-bottom-tablet']"
          :shaftDiagramData="shaftDiagramData"
          :shaftDiagramVisible="$route.params.elementType !== 'stations'"
          @updateElementPosition="updateElementGeometry"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, reactive, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import I18n from 'i18n-js';

import useAjax from '@/functions/use_ajax';
import ArrowLeftSvg from '@/images/arrow_left.svg';
import GroupSelect from '@/components/shafts/definition/group_select.vue';
import FormRow from '@/components/form/row.vue';
import { capitalize } from '@/functions/utils';
import { convertToUnderscore } from '@/functions/convert_to_underscore';

import HeaderBar from '@/components/generic/header_bar.vue';
import Loader from '@/components/generic/loader.vue';
import FormSubmitButton from '@/components/form/form_submit_button.vue';
import DefinitionDiagram from '@/components/shafts/definition/definition_diagram.vue';
import { useShaft } from '@/functions/use_remote_object';

const props = defineProps({
  organisationId: { type: String, required: true },
  shaftId: { type: String, required: true },
  elementId: { type: String, required: false, default: '' },
  elementType: { type: String, required: true },
});

const route = useRoute();
const router = useRouter();
const ajax = useAjax();
const shaft = useShaft(props);
const loading = ref(true);
const loadingDiagram = ref(null);
const crossSectionElements = ref(null);
const shaftElementGroups = ref(null);
const activeElement = ref(null);
const errors = ref(null);
const saving = ref(null);
const selectedGroup = ref(null);
const startSetWasTouched = ref(false);
const endSetWasTouched = ref(false);
const riskList = ref(null);
const sizeList = ref(null);
const typeList = ref(null);
const showWidthAndHeight = ref(true);
const minMaxBoundary = ref({
  min: 1,
  max: 300,
});

onMounted(() => {
  prepareList(props.elementType);
  loadElement();
  loadShaftDiagram();
  loadShaftGroup();
});

const element = reactive(createNewElement());
function createNewElement() {
  return {
    id: 'new',
    name: null,
    symbol: null,
    element_type: props.elementType,
    start_set: null,
    end_set: null,
    risk_to_skip: false,
    risk_to_cage: false,
    risk_to_man_cage: false,
    risk_to_service_cage: false,
    shaft_element_group_id: null,
    geometry: {
      x: null,
      y: null,
      width: null,
      height: null,
      type: null,
      size: null,
    },
  };
}

const elementPath = computed(() => {
  if (props.elementId)
    return `/organisations/${props.organisationId}/shafts/${props.shaftId}/shaft_elements/${props.elementId}`;
  else
    return `/organisations/${props.organisationId}/shafts/${props.shaftId}/shaft_elements`;
});

/**
 * Find and set new data to element item in the diagram
 */
const updateDiagram = () => {
  const checkForElementType =
    !!shaftDiagramData.value.elements[props.elementType];
  if (!checkForElementType)
    shaftDiagramData.value.elements[props.elementType] = [];
  const currentElementGroup =
    shaftDiagramData.value.elements[props.elementType];
  const foundIndex = currentElementGroup.findIndex(
    (result) => result.id === activeElement.value.id || result.id === 'new'
  );

  if (foundIndex !== -1) {
    currentElementGroup[foundIndex].symbol = element.symbol;
    currentElementGroup[foundIndex].geometry = activeElement.value.geometry;
  } else {
    const newItem = {
      id: 'new',
      name: element.name,
      symbol: element.symbol,
      element_type: props.elementType,
      geometry: element.geometry,
    };
    activeElement.value = element;
    activeElement.value.id = 'new';
    activeElement.value.element_type = props.elementType;
    currentElementGroup.push(newItem);
  }
};

/**
 * Get active element data
 */
const loadElement = async () => {
  if (props.elementId) {
    let { ok, data } = await ajax(
      `/organisations/${props.organisationId}/shafts/${props.shaftId}/shaft_elements/${props.elementId}`
    );

    if (ok) {
      activeElement.value = data;
      Object.assign(element, data);
    }
  } else {
    activeElement.value = createNewElement();
  }
};

/**
 * Get shaft cross-section diagram data
 */
const loadShaftDiagram = async () => {
  loadingDiagram.value = true;

  let { ok, data } = await ajax(
    `/organisations/${props.organisationId}/shafts/${props.shaftId}/dashboard/geometry`
  );

  if (ok) {
    crossSectionElements.value = data;
  }

  loadingDiagram.value = false;
};

/**
 * Get shaft element groups
 */
const loadShaftGroup = async () => {
  loading.value = true;

  let { ok, data } = await ajax(
    `/organisations/${props.organisationId}/shafts/${props.shaftId}/shaft_element_groups`
  );

  if (ok) {
    const specificElementGroupList =
      data.filter((result) => {
        return (
          result.element_type.toLowerCase() ===
          props.elementType.toString().toLowerCase()
        );
      }) || [];

    shaftElementGroups.value = specificElementGroupList.map((item) => {
      return {
        name: item.name,
        id: item.id,
      };
    });

    selectedGroup.value = shaftElementGroups.value.find(
      (result) => result.id === route.params.elementGroupId
    );
  }

  loading.value = false;
};

/**
 * Data for the shaft diagram,
 * passed through the DefinitionDiagram component
 */
const shaftDiagramData = computed(() => {
  return {
    elements: crossSectionElements.value,
    shape: shaft.value?.shape,
    activeItem: activeElement.value,
  };
});

/**
 * Prepares the button label text by:
 * making it singular and setting it to sentence case
 */
const elementNameText = computed(() => {
  const elementTypeText = I18n.t(
    `shafts.element_types.shaft.${props.elementType}`
  );
  if (elementTypeText.slice(elementTypeText.length - 1).toLowerCase() !== 's')
    return elementTypeText;
  return capitalize(elementTypeText).slice(0, -1);
});

const addLabel = computed(() => {
  if (!elementNameText?.value) return;
  return elementNameText.value.toLowerCase();
});

/**
 * Checks for empty string values
 * and if any it sets them to null
 */
function removeEmptyString(target) {
  for (var key in target) {
    if (target[key] === '') {
      target[key] = null;
    }
  }
}

/**
 * Prepares the data to be submitted
 */
const formatGroupAttributes = () => {
  return {
    shaft_element_group_id: selectedGroup.value?.id || null,
  };
};

const formatElementForPost = async () => {
  removeEmptyString(element.geometry);

  let elementParams = {
    ...element,
    geometry: element.geometry,
    ...formatGroupAttributes(),
  };

  return elementParams;
};

/**
 * Checks for any errors and submits if there are none
 */
const saveNewElement = async () => {
  const testStartSet = errors?.value?.shaft_element?.start_set;
  const testEndSet = errors?.value?.shaft_element?.end_set;
  const testType = errors?.value?.shaft_element?.type;
  const hasSkipAndCage =
    props.elementType === 'skips_and_cages' ? testType : false;

  if (testStartSet || testEndSet || hasSkipAndCage) return;
  errors.value = null;
  saving.value = true;
  let method = props.elementId ? 'PATCH' : 'POST';
  let { ok, data } = await ajax(elementPath.value, {
    method,
    body: await formatElementForPost(),
  });

  if (ok) {
    router.replace({
      name: 'shaftGroup',
      params: { shaftId: data.shaft_id, elementType: data.element_type },
    });
  } else {
    errors.value = data;

    if (element.geometry.type) return (saving.value = false);
    const errorTypeMessage = [I18n.t('activerecord.errors.must_be_checked')];
    setValidationMessage(errorTypeMessage, 'type');
  }

  saving.value = false;
};

/**
 * Listens to the start_set and end_set fields for changes,
 * runs the validations and sets errors accordingly
 */
watch(
  () => element.start_set,
  (value) => {
    startSetWasTouched.value = true;
    const testBlankAndNan = validateInput('start_set', 'number');
    const shaftNumberOfSets = parseFloat(shaft.value?.number_of_sets);

    !testBlankAndNan && validateSet(value, element.end_set, 'start_set');
    !testBlankAndNan &&
      validateSet(element.end_set, element.start_set, 'end_set');
    !testBlankAndNan && rangeValidation(value, shaftNumberOfSets, 'start_set');
  }
);

watch(
  () => element.end_set,
  (value) => {
    endSetWasTouched.value = true;
    const testBlankAndNan = validateInput('end_set', 'number');
    const shaftNumberOfSets = parseFloat(shaft.value?.number_of_sets);

    !testBlankAndNan && validateSet(value, element.start_set, 'end_set');
    !testBlankAndNan &&
      validateSet(element.start_set, element.end_set, 'start_set');
    !testBlankAndNan && rangeValidation(value, shaftNumberOfSets, 'end_set');
  }
);

watch(
  () => element.geometry?.type,
  () => {
    clearValidationMessage('type');
  }
);

watch(
  () => element.geometry?.size,
  () => {
    clearValidationMessage('size');
  }
);

watch(
  () => element.geometry,
  () => {
    !element?.id || element?.id === 'new' && updateDiagram();
  }
);

function validateSet(value, limit, key) {
  if (isNaN(element?.start_set) || isNaN(element?.end_set)) return;
  if (!element?.start_set || !element?.end_set) return;

  const newValue = parseFloat(value);
  const test =
    !!newValue && key === 'start_set' ? newValue <= limit : newValue >= limit;

  const shaftNumberOfSets = parseFloat(shaft.value?.number_of_sets);
  const startSet = parseFloat(element?.start_set);
  const endSet = parseFloat(element?.end_set);

  const setTest =
    startSet === 0 ||
    endSet === 0 ||
    startSet > shaftNumberOfSets ||
    endSet > shaftNumberOfSets;

  if (!!newValue && test && !setTest) return clearValidationMessage(key);
  const label = key === 'start_set' ? 'max_limit' : 'min_limit';
  const zeroMessage = [
    I18n.t('activerecord.errors.between_set', { type: shaftNumberOfSets }),
  ];
  const defaultMessage = [
    I18n.t(`activerecord.errors.${label}`, { type: !limit ? 1 : limit }),
  ];
  const errorMessage = setTest ? zeroMessage : defaultMessage;

  if (!setTest) return setValidationMessage(errorMessage, key);
  setValidationMessage(errorMessage, 'start_set');
  setValidationMessage(errorMessage, 'end_set');
}

function validateInput(key, type) {
  const value = element[key] || element.geometry[key];
  let errorMessage;

  if (typeof value === 'string' && !value) {
    errorMessage = [I18n.t('activerecord.errors.blank')];
    if (type === 'number') errorMessage.push(I18n.t('activerecord.errors.NAN'));

    return setValidationMessage(errorMessage, key);
  }

  if (type === 'number') {
    errorMessage = [I18n.t('activerecord.errors.NAN')];
    if (isNaN(value)) return setValidationMessage(errorMessage, key);

    errorMessage = [I18n.t('activerecord.errors.min_limit', { type: 1 })];
    if (value === 0) return setValidationMessage(errorMessage, key);
  }

  clearValidationMessage(key);
}

function rangeValidation(value, limit, key) {
  if (isNaN(limit) || (value <= limit && value > 0)) return;
  const message = [I18n.t('activerecord.errors.between_set', { type: limit })];
  return setValidationMessage(message, key);
}

function setValidationMessage(message, key) {
  if (errors?.value?.shaft_element)
    return (errors.value.shaft_element[key] = message);
  return (errors.value = {
    shaft_element: {
      [key]: message,
    },
  });
}

function clearValidationMessage(key) {
  !!errors?.value?.shaft_element && (errors.value.shaft_element[key] = null);
}

function updateElementGeometry(data) {
  element.geometry = {
      type: element.geometry.type,
      size: element.geometry.size,
      ...data
    };
  activeElement.value['geometry'] = element.geometry;
}

function prepareList(value) {
  // missing stations
  switch (value) {
    case 'pipe_dividers':
    case 'sidewalls':
    case 'brattice_walls':
    case 'guides':
    case 'wall_brackets':
    case 'buntons':
      riskGroup();
      break;
    case 'pipes':
      riskGroup();
      sizeGroup();
      typeGroup();
      showWidthAndHeight.value = false;
      break;
    case 'skips_and_cages':
      typeGroup(true);
      break;
    case 'cables':
      riskGroup();
      sizeGroup();
      showWidthAndHeight.value = false;
      break;
  }
}

function riskGroup() {
  riskList.value = [
    {
      name: 'risk',
      value: 'skip',
    },
    {
      name: 'risk',
      value: 'man cage',
    },
    {
      name: 'risk',
      value: 'Service cage',
    },
  ];
}

function sizeGroup() {
  sizeList.value = [
    {
      name: 'size',
      label: 'small',
      value: 5,
    },
    {
      name: 'size',
      label: 'medium',
      value: 10,
    },
    {
      name: 'size',
      label: 'large',
      value: 15,
    },
    {
      name: 'size',
      label: 'extra large',
      value: 25,
    },
  ];
}

function typeGroup(on) {
  switch (on) {
    case true:
      typeList.value = [
        {
          name: 'type',
          value: 'skip',
        },
        {
          name: 'type',
          value: 'cage',
        },
      ];
      break;
    default:
      typeList.value = [
        {
          name: 'type',
          value: 'air',
        },
        {
          name: 'type',
          value: 'water',
        },
        {
          name: 'type',
          value: 'cement',
        },
        {
          name: 'type',
          value: 'mud',
        },
      ];
  }
}
</script>
<style scoped lang="scss">
@import "@/stylesheets/global";

hr {
  border: bu(0.05) solid map-get($background-color, lighter);
  background-color: map-get($background-color, lighter);
  margin: bu(4) 0 bu(2) 0;
}

.floating-svg {
  position: absolute;
}

.relate-svg-group {
  position: relative;
  &::before {
    content: '';
    width: bu(1.3);
    height: bu(2.5);
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    bottom: bu(3);
    background-image: url('@/images/relate.svg');
    background-repeat: no-repeat, repeat;

    @include breakpoint(small) {
      display: block;
    }

    @include breakpoint(medium) {
      display: none;
    }
  }

  &__error {
    &::before {
      bottom: bu(5.5);
    }
  }
}

.relate-svg-item {
  position: relative;

  &::before {
    content: '';
    width: bu(1.3);
    height: bu(2.5);
    position: absolute;
    right: bu(-1.7);
    top: bu(1.5);
    background-image: url('@/images/relate.svg');
    background-repeat: no-repeat, repeat;

    @include breakpoint(small) {
      display: none;
    }

    @include breakpoint(medium) {
      display: block;
    }
  }
}
</style>
